import {Key} from 'react';

import {submitGroupCompanyApi} from '../api';
import {IPostISubmitGroupCompany, ISubmitGroupCompanyDto} from '../api/types';
import {IGetDataArgs} from '../model/types';

export const SubmitGroupCompanyTabService = {
    get: async (args?: IGetDataArgs) => {
        try {
            const response = await submitGroupCompanyApi.getData(args);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    getById: async (id: number) => {
        try {
            return await submitGroupCompanyApi.getDataById(id);
        } catch (error) {
            throw new Error(error);
        }
    },

    post: async (args: IPostISubmitGroupCompany) => {
        try {
            const response = await submitGroupCompanyApi.postData(args);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    put: async (args: ISubmitGroupCompanyDto) => {
        try {
            const response = await submitGroupCompanyApi.putData(args);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    delete: async (rowsIds: {rowsIds: Key[]}) => {
        try {
            const response = await submitGroupCompanyApi.deleteData(rowsIds);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },

    sendService: async (values: any) => {
        try {
            const response = await submitGroupCompanyApi.sendService(values);

            return {response, isError: false};
        } catch (error) {
            console.error(error);

            return {response: error.response, isError: true};
        }
    },
};
